import axios from 'axios'

import {API_URL} from "../utils/consts";
import getLanguagePath from "../utils/getLanguagePath";

const api = axios.create({
  withCredentials: true,
  baseURL: API_URL
});

api.interceptors.request.use(config => {
  const currentLanguageCode = getLanguagePath();

  config.params = {
    lang: currentLanguageCode,
    ...config.params,
  };
  return config;
});

export default api